import styled from 'styled-components'

export const Upper = styled.span`
	text-transform: uppercase;
`